"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EthereumTBTCToken = void 0;
const contracts_1 = require("../contracts");
const ethers_1 = require("ethers");
const bitcoin_1 = require("../bitcoin");
const utils_1 = require("../utils");
const adapter_1 = require("./adapter");
const address_1 = require("./address");
const TBTC_json_1 = __importDefault(require("./artifacts/mainnet/TBTC.json"));
const TBTC_json_2 = __importDefault(require("./artifacts/sepolia/TBTC.json"));
const TBTC_json_3 = __importDefault(require("@keep-network/tbtc-v2/artifacts/TBTC.json"));
/**
 * Implementation of the Ethereum TBTC v2 token handle.
 * @see {TBTCToken} for reference.
 */
class EthereumTBTCToken extends adapter_1.EthersContractHandle {
    constructor(config, chainId = contracts_1.Chains.Ethereum.Local) {
        let deployment;
        switch (chainId) {
            case contracts_1.Chains.Ethereum.Local:
                deployment = TBTC_json_3.default;
                break;
            case contracts_1.Chains.Ethereum.Sepolia:
                deployment = TBTC_json_2.default;
                break;
            case contracts_1.Chains.Ethereum.Mainnet:
                deployment = TBTC_json_1.default;
                break;
            default:
                throw new Error("Unsupported deployment type");
        }
        super(config, deployment);
    }
    // eslint-disable-next-line valid-jsdoc
    /**
     * @see {TBTCToken#getChainIdentifier}
     */
    getChainIdentifier() {
        return address_1.EthereumAddress.from(this._instance.address);
    }
    // eslint-disable-next-line valid-jsdoc
    /**
     * @see {TBTCToken#totalSupply}
     */
    async totalSupply(blockNumber) {
        return this._instance.totalSupply({
            blockTag: blockNumber !== null && blockNumber !== void 0 ? blockNumber : "latest",
        });
    }
    // eslint-disable-next-line valid-jsdoc
    /**
     * @see {TBTCToken#requestRedemption}
     */
    async requestRedemption(walletPublicKey, mainUtxo, redeemerOutputScript, amount) {
        var _a, _b;
        const redeemer = await ((_b = (_a = this._instance) === null || _a === void 0 ? void 0 : _a.signer) === null || _b === void 0 ? void 0 : _b.getAddress());
        if (!redeemer) {
            throw new Error("Signer not provided");
        }
        const vault = await this._instance.owner();
        const extraData = this.buildRequestRedemptionData(address_1.EthereumAddress.from(redeemer), walletPublicKey, mainUtxo, redeemerOutputScript);
        const tx = await adapter_1.EthersTransactionUtils.sendWithRetry(async () => {
            return await this._instance.approveAndCall(vault, amount, extraData.toPrefixedString());
        }, this._totalRetryAttempts);
        return utils_1.Hex.from(tx.hash);
    }
    // eslint-disable-next-line valid-jsdoc
    /**
     * @see {TBTCToken#buildRequestRedemptionData}
     */
    buildRequestRedemptionData(redeemer, walletPublicKey, mainUtxo, redeemerOutputScript) {
        const { walletPublicKeyHash, prefixedRawRedeemerOutputScript, mainUtxo: _mainUtxo, } = this.buildBridgeRequestRedemptionData(walletPublicKey, mainUtxo, redeemerOutputScript);
        return utils_1.Hex.from(ethers_1.utils.defaultAbiCoder.encode(["address", "bytes20", "bytes32", "uint32", "uint64", "bytes"], [
            redeemer.identifierHex,
            walletPublicKeyHash,
            _mainUtxo.txHash,
            _mainUtxo.txOutputIndex,
            _mainUtxo.txOutputValue,
            prefixedRawRedeemerOutputScript,
        ]));
    }
    buildBridgeRequestRedemptionData(walletPublicKey, mainUtxo, redeemerOutputScript) {
        const walletPublicKeyHash = bitcoin_1.BitcoinHashUtils.computeHash160(walletPublicKey).toPrefixedString();
        const mainUtxoParam = {
            // The Ethereum Bridge expects this hash to be in the Bitcoin internal
            // byte order.
            txHash: mainUtxo.transactionHash.reverse().toPrefixedString(),
            txOutputIndex: mainUtxo.outputIndex,
            txOutputValue: mainUtxo.value,
        };
        // Convert the output script to raw bytes buffer.
        const rawRedeemerOutputScript = redeemerOutputScript.toBuffer();
        // Prefix the output script bytes buffer with 0x and its own length.
        const prefixedRawRedeemerOutputScript = `0x${Buffer.concat([
            Buffer.from([rawRedeemerOutputScript.length]),
            rawRedeemerOutputScript,
        ]).toString("hex")}`;
        return {
            walletPublicKeyHash,
            mainUtxo: mainUtxoParam,
            prefixedRawRedeemerOutputScript,
        };
    }
}
exports.EthereumTBTCToken = EthereumTBTCToken;
//# sourceMappingURL=tbtc-token.js.map